(function () {
    'use strict';

    angular.module("imApp").factory("webpageSettingMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            listWebPageSettings: function (parms) {
                return $ihttp.post({
                    method: 114,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
